import { Button, Result } from "antd";
import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { loginActions } from "../../../../pages/LoginPage/reducer";
import { selectPermissions } from "../../../../util/store/selectors";
import { OP_STATUS } from "../../../../util/varibles/constants";
import { IPropsChildren } from '../../../../util/varibles/interface';
import { ACTION } from "../../../../util/varibles/permission";
import stylesOp from "../../Operations/Operation/style.module.scss";
import Note from "../Note";
import NextStep from "./NextStep";
import styles from './style.module.scss';
import ViewStep from "./ViewStep";

const Views: { [id: string]: React.FC<IPropsChildren> } = {
    [OP_STATUS.APPROVED]: () => {
        return <div className='flex justify-center'>
            <NextStep name='start operation'>
                Start operation
            </NextStep>
        </div>
    },
    [OP_STATUS.PROCESSING]: () => {
        const [step] = useTrackingOp(state => state.step);
        const [activity_log = []] = useTrackingOp(state => state.op?.activity_log);
        const minStep = Math.max(step, 0);

        return <ViewStep data={activity_log[minStep]} next={activity_log[minStep + 1]}>
            <div className={stylesOp['operation-step-content']}>
                <Note />
            </div>
        </ViewStep>
    },
    [OP_STATUS.FINISHED]: () => {
        const dispatch = useDispatch();

        return <Result
            status="success"
            title={<div className='font-s16 font-w4'>Operation is completed</div>}
            extra={<div className='flex justify-content-center'>
                <Button className='bt-primary' onClick={() => dispatch(loginActions.getOpsOfVessel())}>
                    Continue
                </Button>
            </div>}
        />
    }
}

const StepControl: React.FC = () => {
    const [op] = useTrackingOp(state => state.op);

    const [canUpdateVesselSide] = useSelector(selectPermissions([ACTION.VESSEL_SIDE.UPDATE]))

    if (!canUpdateVesselSide)
        return null;

    const { status = "" } = op?.operation || {};
    const { [status]: View } = Views;

    return <div className={styles.control}>
        {View && <View />}
    </div>;
};


export default StepControl;
